<template>
    <div class="banner-bg">
        <div class="banner">
            <swiper :options="swiperOption">
                <swiper-slide
                    v-for="(item, index) in bannerList"
                    :key="item.id"
                    :data-index="index"
                    :data-el-id="`graph_${item.id}`">
                    <img class="image-box" :src="item.display_carousel_pic" />
                </swiper-slide>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
        </div>
    </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
let vm = null;

export default {
    name: 'banner',
    components: {
        swiper,
        swiperSlide
    },
    props: {
        bannerList: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            swiperOption: {
                loop: true,
                autoplay: {
                    delay: 5000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                on: {
                    click: (e) => {
                        const bannerIndex = e.target.dataset.index;
                        const elId = e.target.dataset.elId;
                        elId && vm.clickBanner({ bannerIndex, elId });
                    },
                },
                // 设置显示的个数
                slidesPerView: 1,
                spaceBetween: 30,
                centeredSlides: true,
                // 3D效果
                effect: 'coverflow',
                grabCursor: true,

                // 设置点击箭头
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true, //修改swiper的父元素时，自动初始化swiper
            }
        };
    },
    created () {
        vm = this;
    },
    methods: {
        clickBanner ({ bannerIndex, elId }) {
            this.$emit('clickBanner', { bannerIndex, elId});
        },
        scroll2IpGraph (bannerIndex) {
            const graph = this.bannerList[bannerIndex];
            console.log(graph);
            const domId = `graph_${graph.id}`;
            const dom = document.getElementById(domId);
            console.log(dom, graph.cover_pic_name, graph.cover_pic_desc);
            console.log(dom.getAttribute('data-index'));
            const index = dom.getAttribute('data-index');
            const height = dom.offsetTop;
            //dom.scrollIntoView();
            window.scrollTo({
                top: height,
                behavior: 'smooth'
            });
            this.$emit('openDetail', graph, index);
        }
    },
};
</script>

<style lang='scss' scoped>
@import "@/css/common.scss";
.banner-bg{
    width: 100%;
    background: url('../img/banner_bg.png') no-repeat;
    background-size: cover;
}
.banner{
    margin:0 auto vws(70px);
    width: 1184px;
    .swiper-button-prev{
        background-image: url("../img/swiper-pre.png");
    }
    .swiper-button-next{
        background-image: url("../img/swiper-next.png");
    }
    .swiper-button-prev,.swiper-button-next{
        background-size: 53px 53px;
        width: 53px;
        height: 53px;
    }
    .image-box{
        width: 100%;
        // height: 328px;
    }
}
@media (max-width:1184px) {
    .banner{
        width:100%;
        height: unset;
        .swiper-button-prev,.swiper-button-next{
            background-size: 43px 43px;
            width: 43px;
            height: 43px;
        }
    }
}
@media (max-width: 720px){
    .banner{
        .swiper-button-prev,.swiper-button-next{
            background-size: 33px 33px;
            width: 33px;
            height: 33px;
        }
    }
}
@media (max-width: 480px){
    .banner{
        .swiper-button-prev,.swiper-button-next{
            background-size: 23px 23px;
            width: 23px;
            height: 23px;
            transform: translateY(50%)
        }
    }
}
</style>


